import React, { useState } from "react";
// import Loader from "../../Loader";
import cx from "classnames";
import "./style.scss";

const GridFloatingButton = ({ onGridFloatingButtonClick }) => {
    const [isLoading, setIsLoading] = useState(false);
    function handleClick() {
        if (
            typeof onGridFloatingButtonClick === "object" &&
            onGridFloatingButtonClick.asyncHandler &&
            typeof onGridFloatingButtonClick.asyncHandler === "function"
        ) {
            const { asyncHandler } = onGridFloatingButtonClick;
            if (asyncHandler) {
                setIsLoading(true);
                asyncHandler().finally(() => {
                    setIsLoading(false);
                });
            }
        } else {
            onGridFloatingButtonClick();
        }
    }

    return (
        <button
            className={cx("grid-floating-button", { disabled: isLoading })}
            disabled={isLoading}
            onClick={handleClick}
        >
            {/* +{isLoading && <Loader />} */}
            +
        </button>
    );
};

export default GridFloatingButton;
